import React from 'react';
import PropTypes from 'prop-types';

import { routeNaming, AppLink } from '../../../routes';
import { enforceMenus } from '../../../hocs/enforce-menus';
import { MenuStore } from '../../../stores/MenuStore';
import { MenuImage } from '../menu-image';
import iconClose from '../../../assets/images/icon-close.svg';
import styles from './MenuOverlay.css';

const IPropTypes = {
  className: PropTypes.string,
  menuId: PropTypes.string.isRequired,
  onBackgroundHover: PropTypes.func,
  onClose: PropTypes.func,
};

const defaultProps = {
  className: '',
  onBackgroundHover: () => {},
  onClose: () => {},
};

const ESCAPE_KEY = 'Escape';
const closeOnEscape = onClose => (event) => {
  if (event.key === ESCAPE_KEY) {
    onClose();
  }
};

const stopPropagation = event => event.stopPropagation();

const MenuOverlay = (props) => {
  const menu = MenuStore.menus.find(item => item.id === props.menuId);
  const subMenus = menu.subMenus.map((subMenu) => {
    const productTypes = subMenu.productTypes.map(productType => (
      <AppLink
        className={styles.productType}
        key={productType.id}
        routeName={routeNaming.PRODUCT_INDEX}
        pathParams={{ subMenuId: subMenu.id }}
        queryParams={{ pt: productType.id }}
      >
        {productType.name}
      </AppLink>
    ));
    return (
      <div
        className={styles.subMenu}
        key={subMenu.id}
      >
        <AppLink
          routeName={routeNaming.PRODUCT_INDEX}
          pathParams={{ subMenuId: subMenu.id }}
        >
          <h4 className={styles.subMenuName}>{subMenu.name}</h4>
        </AppLink>
        {productTypes}
        <AppLink
          className={styles.seeAll}
          routeName={routeNaming.PRODUCT_INDEX}
          pathParams={{ subMenuId: subMenu.id }}
        >
          Ver todos
        </AppLink>
      </div>
    );
  });
  return (
    <div
      className={[styles.container, props.className].join(' ')}
      role="presentation"
      onClick={props.onClose}
      onKeyPress={closeOnEscape}
      onFocus={props.onBackgroundHover}
      onMouseOver={props.onBackgroundHover}
    >
      <div
        className={styles.internalContainer}
        role="presentation"
        onClick={stopPropagation}
        onFocus={stopPropagation}
        onMouseOver={stopPropagation}
      >
        <div className={styles.popUp}>
          <div className={styles.linkWrapper}>
            <div className={styles.linkContainer}>
              {subMenus}
            </div>
          </div>
          {
            !!menu.imageUrl &&
            <div className={styles.imageContainer}>
              <MenuImage className={styles.image} src={menu.imageUrl} />
            </div>
          }
          <button
            className={styles.closeIcon}
            onClick={props.onClose}
          >
            <img src={iconClose} alt="" />
          </button>
        </div>
      </div>
    </div>
  );
};

MenuOverlay.propTypes = IPropTypes;
MenuOverlay.defaultProps = defaultProps;

const WrappedMenuOverlay = enforceMenus(MenuOverlay);

export { WrappedMenuOverlay as MenuOverlay };



// WEBPACK FOOTER //
// ./src/common/home-navbar/menu-overlay/MenuOverlay.jsx